import React, { useState, useEffect } from "react";
import "./alltransaction.scss";
import DataTable from "./DataTable/DataTable";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { Api_Url } from "../../../utils/ApiUrl";
import { useHistory } from "react-router-dom";
import Accordion from "react-bootstrap/Accordion";
import Dropdown from "react-bootstrap/Dropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import { CSVLink } from "react-csv";
import { toast } from "react-toastify";
import moment from "moment";
import Environment from "../../../utils/Environment";

const AllTransaction = ({
  user,
  setindexwait,
  tomiPrice,
  usdPrice,
  btcPrice,
  pepePrice,
  linkPrice,
  uniPrice,
  dopPrice,
}) => {
  const [codeDataCall, setCodeDataCall] = useState();
  const tok = localStorage?.getItem("accessToken");
  const project = localStorage.getItem("project");

  const [leaderNames, setLeaderNames] = useState([]);
  const [leaderNames2, setLeaderNames2] = useState([]);

  const [transactionApiCalled, setTransactionApiCalled] = useState(false);
  const [data, setData] = useState([]);
  const [totalT, setTotalT] = useState(0);
  const [purchases, setPurchases] = useState(null);
  const [dops, setDops] = useState(null);
  const [earnings, setEarnings] = useState(null);
  const [total, setTotal] = useState(0);
  // const [usdPrice, setUsdPrice] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [code, setCode] = useState([]);
  const [pc, setPC] = useState(0);
  const [pmc, setPMC] = useState(0);
  const [nrc, setNRC] = useState(0);
  const [lc, setLC] = useState(0);
  const [dpc, setDPC] = useState(0);
  const [lec, setLEC] = useState(0);
  const [mm, setmm] = useState(0);
  const [ss, setss] = useState(0);
  const [gg, setgg] = useState(0);
  const [pee, setPEE] = useState(0);
  const [peu, setPEU] = useState(0);
  const [pet, setPET] = useState(0);
  const [peUsdc, setPEUsdc] = useState(0);

  const [peBtc, setPEBTC] = useState(0);
  const [pePepe, setPEPepe] = useState(0);
  const [peLink, setPELink] = useState(0);
  const [peUni, setPEUni] = useState(0);
  const [peDop, setPEDop] = useState(0);

  const [pdp, setPDP] = useState(0);
  const [ind, setIND] = useState(0);
  const [dt, setDT] = useState(0);
  const [adminobj, setadminobj] = useState();
  const [search, setSearch] = useState("");
  const [searchBy, setSearchBy] = useState("transactionHashFilter");
  const [myTree, setMyTree] = useState(false);
  const [tokenNftStats, setTokenNftStats] = useState();

  const [claimsCSVData, setClaimsCSVData] = useState([]);
  const [claimsCSVDataHeaders, setClaimsCSVDataHeaders] = useState([]);
  const [loading, setLoading] = useState("");
  const [showbtn, setShowBtn] = useState(true);

  const [typeFilter, setTypeFilter] = useState("");
  const [orderField, setOrderField] = useState("transactionTime");
  const [orderDirection, setOrderDirection] = useState("-1");
  const history = useHistory();

  // const [tomiPrice, setTomiPrice] = useState("");
  const userObj = JSON.parse(localStorage.getItem("user"));
  const [roundsData, setRoundsData] = useState([]);

  const [privateSaleFilter, setPrivateSaleFilter] = useState([]);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedLeaders, setSelectedLeaders] = useState([]);
  const [walletAndCode, setWalletAndCode] = useState([]);
  const [selectedWallets, setSelectedWallets] = useState([]);
  const [selectedAccessCodes, setSelectedAccessCodes] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [searchInputAccessCodes, setSearchInputAccessCodes] = useState("");

  const [filteredWallets, setFilteredWallets] = useState([]);
  const [filteredAccessCodes, setFilteredAccessCodes] = useState([]);

  const [searchInputLeaders, setSearchInputLeaders] = useState("");

  const flattenNestedArrays = (nestedArray) => {
    let result = [];

    const flatten = (array) => {
      array.forEach((item) => {
        result.push(item);

        Object.keys(item).forEach((key) => {
          if (Array.isArray(item[key]) && item[key].length > 0) {
            flatten(item[key]);
          }
        });
      });
    };

    flatten(nestedArray);
    return result;
  };
  const handleSearchChangeLeaders = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchInputLeaders(searchValue);

    if (searchValue === "") {
      // Restore the original data when search is cleared
      setLeaderNames2(leaderNames);
    } else {
      const flattened = flattenNestedArrays(leaderNames); // Flatten the original data for searching
      const filtered = flattened.filter((item) =>
        item.name.toLowerCase().includes(searchValue)
      );
      setLeaderNames2(filtered);
    }
  };

  const handleSearchChangeWallet = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchInput(searchValue);

    if (searchValue === "") {
      setFilteredWallets(walletAndCode?.buyersWallet || []);
    } else {
      const filtered = walletAndCode?.buyersWallet?.filter((item) =>
        item?.buyersWallet?.toLowerCase().includes(searchValue)
      );
      setFilteredWallets(filtered);
    }
  };

  const handleSearchChangeAccessCodes = (e) => {
    const searchValue = e.target.value.toLowerCase();
    setSearchInputAccessCodes(searchValue);

    if (searchValue === "") {
      setFilteredAccessCodes(walletAndCode?.accessCode || []);
    } else {
      const filtered = walletAndCode?.accessCode?.filter((item) =>
        item?.accessCode?.toLowerCase().includes(searchValue)
      );
      setFilteredAccessCodes(filtered);
    }
  };

  const handleCheckboxChangeAccessCodes = (wallet) => {
    setSelectedAccessCodes((prevSelectedWallets) =>
      prevSelectedWallets.includes(wallet)
        ? prevSelectedWallets.filter((item) => item !== wallet)
        : [...prevSelectedWallets, wallet]
    );
  };

  const handleCheckboxChangeWallet = (wallet) => {
    setSelectedWallets((prevSelectedWallets) =>
      prevSelectedWallets.includes(wallet)
        ? prevSelectedWallets.filter((item) => item !== wallet)
        : [...prevSelectedWallets, wallet]
    );
  };
  const handleCheckboxChangeRounds = (projectName, round = null) => {
    // console.log("checkbox filter: ", projectName, round);

    setPrivateSaleFilter((prevFilters) => {
      const existingProject = prevFilters.find(
        (item) => item.privateSale === projectName
      );

      if (existingProject) {
        // If the project exists in the filter
        if (round) {
          // If a specific round is being checked/unchecked
          const updatedRounds = existingProject.round.includes(round)
            ? existingProject.round.filter((r) => r !== round)
            : [...existingProject.round, round];

          // If no rounds are left after unchecking, remove the project entirely
          if (updatedRounds.length === 0) {
            return prevFilters.filter(
              (item) => item.privateSale !== projectName
            );
          }

          // Update the rounds for this project
          return prevFilters.map((item) =>
            item.privateSale === projectName
              ? { ...item, round: updatedRounds }
              : item
          );
        } else {
          // If no specific round is passed, remove the entire project from the filter
          return prevFilters.filter((item) => item.privateSale !== projectName);
        }
      } else {
        // If the project doesn't exist in the filter
        return [
          ...prevFilters,
          {
            privateSale: projectName,
            round: round ? [round] : [],
          },
        ];
      }
    });
  };
  const roles = [
    "god_agent",
    "mega_agent",
    "super_agent",
    "agent",
    "mini_agent",
  ];
  const getLeaderNames = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/leaders-tree`,
      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    axios(config)
      .then(function (response) {
        setLeaderNames(response?.data?.data?.data);
        setLeaderNames2(response?.data?.data?.data);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
      });
  };

  const handleCheckboxChange = (role) => {
    setSelectedRoles((prevRoles) => {
      if (role === "all") {
        // If "All Roles" is checked, select/deselect all roles
        if (prevRoles.length === roles.length) {
          return []; // Uncheck all roles
        } else {
          return roles; // Check all roles
        }
      } else {
        // Handle individual role check/uncheck
        if (prevRoles.includes(role)) {
          return prevRoles.filter((r) => r !== role); // Remove role
        } else {
          return [...prevRoles, role]; // Add role
        }
      }
    });
  };
  const isAllRolesSelected = selectedRoles.length === roles.length;

  const getRoundsAndProjects = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/sale-rounds/admin/filter`,
      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    axios(config)
      .then(function (response) {
        // const rounds = response?.data?.data?.find(
        //   (item) => item?.privateSale === "ASTRANOVA"
        // )?.totalRounds;

        // const roundArray = rounds
        //   ? Array(rounds)
        //       .keys()
        //       .map((i) => i + 1)
        //   : [];

        // // console.log("rounds:", roundArray, rounds);
        // for (let i = 0; i < rounds; i++) {
        //   handleCheckboxChangeRounds("ASTRANOVA", i + 1);
        // }
        setRoundsData(response?.data?.data);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
      });
  };

  const getWalletAndCode = () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/transaction-filters-data`,
      headers: {
        Authorization: "Bearer " + tok,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response?.data?.data?.data;
        setWalletAndCode(resData);
        setFilteredWallets(resData?.buyersWallet);
        setFilteredAccessCodes(resData?.accessCode);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // localStorage.removeItem("accessToken");
          // history.push("/");
        }
      });
  };

  useEffect(() => {
    getLeaderNames();
    getRoundsAndProjects();
    getWalletAndCode();
  }, []);

  useEffect(() => {
    if (usdPrice) {
      const controller = getTransactionsData(); // Get controller instance
      return () => controller.abort();
    }
  }, [
    selectedAccessCodes?.length,
    selectedWallets?.length,
    privateSaleFilter?.length,
    selectedLeaders?.length,
    selectedRoles?.length,
    usdPrice,
    user,
    search,
    typeFilter,
    orderField,
    orderDirection,
    page,
    myTree,
  ]);

  const handlePageChange = (e) => {
    const selectedPage = e.selected;

    setPage(selectedPage);
  };

  const toastErrorFunc = () => {
    toast.error("No data found to export");
  };
  const getAllClaimsData = async () => {
    setLoading(true);
    setShowBtn(false);

    var config = {
      responseType: "stream",
      // get api so don't need to add useAdminAllowed();
      url: `${Api_Url}/users/bulk-admin-transaction-export`,
      data: {
        ...(selectedLeaders?.length > 0 && { nameFilter: selectedLeaders }),
        ...(selectedRoles?.length > 0 && { roleFilter: selectedRoles }),
        ...(search &&
          searchBy == "transactionHashFilter" && {
            transactionHashFilter: search,
          }),

        ...(selectedWallets?.length > 0 && {
          walletAddressFilter: selectedWallets,
        }),
        ...(selectedAccessCodes?.length > 0 && {
          accessCodeFilter: selectedAccessCodes,
        }),
        ...(privateSaleFilter?.length > 0 && {
          privateSaleFilter: privateSaleFilter,
        }),

        orderField: orderField,
        orderDirection: orderDirection,
      },
      headers: {
        Authorization: "Bearer " + tok,
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await fetch(config.url, {
        method: "POST",
        body: JSON.stringify(config.data),
        headers: config.headers,
      });
      if (response.status == 429) {
        toast.error("Limit exceeded. Please try again in one minutes.");
        setTimeout(() => {
          setLoading(false);
          setShowBtn(true);
        }, 3000);
      }
      const reader = response.body.getReader();

      let oldData = "";

      while (true) {
        const { done, value } = await reader.read();
        // console.log(done, " done");

        if (done) {
          break;
        }
        oldData += new TextDecoder().decode(value);
      }
      try {
        const parsedData = JSON.parse(oldData);
        // console.log(parsedData, " parsed data");

        const dataForCsv = parsedData?.map((item) => {
          let date = moment(item?.transactionTime).format("DD/MM/YYYY");
          let time = moment(item?.transactionTime).format("hh:mm A");
          let name = item?.leader?.name;
          let role =
            item?.leader?.role === "mini_agent"
              ? "Ambassador"
              : item?.leader?.role === "god_agent"
              ? "God Leader"
              : item?.leader?.role === "super_agent"
              ? "Super Leader"
              : item?.leader?.role === "agent"
              ? "Leader"
              : item?.leader?.role === "mega_agent"
              ? "Mega Leader"
              : "";
          let email = item?.location[0]?.recipientEmail;

          let code = item?.code_code;
          let Hash = item?.transactionHash;
          let walletAddress = item?.by;
          let price = item?.price;
          let paid = item?.totalSaleConverted;
          let amount = item?.dopPurchased;
          let payment = item?.amountInvested;
          let type = item?.type;
          return {
            date: date,
            time: time,
            name: name,
            role: role,
            email: email,
            code: code,
            Hash: Hash,
            walletAddress: walletAddress,
            price: price,
            paid: paid,
            amount: amount,
            payment: payment,
            type: type,
          };
        });
        const headers = [
          { label: "date", key: "date" },
          { label: "time", key: "time" },
          { label: "name", key: "name" },
          { label: "role", key: "role" },
          { label: "customersEmail", key: "email" },

          { label: "code", key: "code" },
          { label: "Hash", key: "Hash" },
          { label: "walletAddress", key: "walletAddress" },
          { label: "price", key: "price" },
          { label: "paid", key: "paid" },
          { label: "amount", key: "amount" },
          { label: "payment", key: "payment" },
          { label: "type", key: "type" },
        ];
        setClaimsCSVData(dataForCsv);
        setClaimsCSVDataHeaders(headers);

        setLoading(false);
      } catch (error) {
        console.error("Error parsing JSON data:", error);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getTransactionsData = () => {
    const controller = new AbortController();
    const signal = controller.signal;
    setTransactions([]);
    setTransactionApiCalled(true);
    // console.log("private sale filter: ", privateSaleFilter);

    var config = {
      method: "post",
      // get api so don't need to add useAdminAllowed();
      url: `${Api_Url}/users/admin/transactions`,
      data: {
        limit: 10,
        offset: page + 1,
        ...(selectedLeaders?.length > 0 && {
          nameFilter: selectedLeaders?.map((leader) => leader?.name),
        }),
        ...(selectedRoles?.length > 0 && { roleFilter: selectedRoles }),
        ...(search && {
          search: search,
        }),

        ...(selectedWallets?.length > 0 && {
          walletAddressFilter: selectedWallets,
        }),
        ...(selectedAccessCodes?.length > 0 && {
          accessCodeFilter: selectedAccessCodes,
        }),
        ...(privateSaleFilter?.length > 0 && {
          privateSaleFilter: privateSaleFilter,
        }),

        orderField: orderField,
        orderDirection: orderDirection,
      },
      headers: {
        Authorization: "Bearer " + tok,
      },
      signal,
    };

    axios(config)
      .then(function (res) {
        if (signal.aborted) return; // Stop execution if request was aborted

        // // console.log("trx data: ", res?.data?.data?.transactions);
        setTransactions(res?.data?.data?.transactions);
        setPageCount(res?.data?.data?.pages);
        setTransactionApiCalled(false);

        // setLoader(false);
      })
      .catch(function (error) {
        if (signal.aborted) return; // Stop execution if request was aborted

        // setLoader(false);
        setTransactionApiCalled(false);
      });
    return controller;
  };

  useEffect(() => {
    if (user?.role == "admin") {
      GetAllRounds();
    } else {
      GetMyData();
    }
  }, [usdPrice, user]);

  const functiontogetback = () => {
    localStorage.setItem("indexvalue", 0);
    setindexwait(0);
  };

  const GetAllRounds = async () => {
    // if (account) {
    var config = {
      method: "get",
      url: `${Api_Url}/users/admin/stats?privateSale=LEIA`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        let value = response?.data?.data;
        // // console.log("value: ", value);
        setTokenNftStats(value);
        if (response?.data?.data?.stats?.length > 0) {
          setadminobj(response?.data?.data?.stats[0]);
        }
      })
      .catch(function (error) {
        // console.log(error);
      });
    // }
  };

  const GetMyData = async () => {
    var config = {
      method: "get",
      url: `${Api_Url}/users/my/stats?privateSale=LEIA`,
      headers: {
        authorization: `Bearer ` + tok,
      },
    };
    axios(config)
      .then(function (response) {
        let value = response?.data?.data;
        // // console.log("sdfsfsdfsdfsdfdsfsdfdf", value);
        setPDP(value?.purchasesAndDopPurchased);
        setPEU(value?.purchasedAndEarningsUsdt);
        setPEE(value?.purchasedAndEarningsEth);
        setPET(value?.purchasedAndEarningsTomi);
        setPEUsdc(value?.purchasedAndEarningsUsdc);
        setPEBTC(value?.purchasedAndEarningsWbtc);
        setPEPepe(value?.purchasedAndEarningsPepe);
        setPELink(value?.purchasedAndEarningsLink);
        setPEUni(value?.purchasedAndEarningsUni);
        setPEDop(value?.purchasedAndEarningsDopToken);

        setIND(value?.inDirectSales);
        setDT(value?.directSales);
        setPC(value?.myPurchasesChange);
        setPMC(value?.myPurchasesAmountChange);
        setLC(value?.myLeadersChange);
        setDPC(value?.myDopPurchasedChange);
        setLEC(value?.myEarningsChange);
        setgg(value?.leaders);
        setmm(value?.megas);
        setss(value?.supers);
      })
      .catch(function (error) {
        if (error?.response?.status == 401) {
          // history.push("/login");
        }
        // console.log(error);
      });
    // }
  };

  const [show3, setShow3] = useState(false);

  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);
  const handleCheckboxChangeLeaders = (leader) => {
    setSelectedLeaders(
      (prevLeaders) =>
        prevLeaders.some((l) => l.id === leader.id)
          ? prevLeaders.filter((l) => l.id !== leader.id) // Remove the leader object if already selected
          : [...prevLeaders, { id: leader.id, name: leader.name }] // Add the leader object if not selected
    );
  };

  const getAllEventKeys = (nodes, keys = []) => {
    nodes.forEach((node) => {
      keys.push(node._id.toString());
      Object.keys(node).forEach((key) => {
        if (Array.isArray(node[key]) && node[key].length > 0) {
          getAllEventKeys(node[key], keys);
        }
      });
    });
    return keys;
  };
  const areAllChildrenSelected = (node) => {
    const childNodes = getAllDescendantNodes(node);
    return childNodes.every((child) =>
      selectedLeaders.some((leader) => leader.id === child._id)
    );
  };

  const getAllDescendantNodes = (node) => {
    let descendants = [node];
    Object.keys(node).forEach((key) => {
      if (Array.isArray(node[key])) {
        node[key].forEach((child) => {
          descendants = descendants.concat(getAllDescendantNodes(child));
        });
      }
    });
    return descendants;
  };
  const handleParentCheckboxChange = (node) => {
    const allDescendants = getAllDescendantNodes(node);
    const descendantObjects = allDescendants.map((descendant) => ({
      id: descendant._id,
      name: descendant.name,
    }));

    let newSelectedLeaders;
    if (areAllChildrenSelected(node)) {
      // Deselect all descendants
      newSelectedLeaders = selectedLeaders.filter(
        (leader) => !descendantObjects.some((desc) => desc.id === leader.id)
      );
    } else {
      // Select all descendants
      newSelectedLeaders = [
        ...new Set([...selectedLeaders, ...descendantObjects]),
      ];
    }

    setSelectedLeaders(newSelectedLeaders);
  };
  const renderHierarchy = (nodes, level = 0) => {
    return nodes.map((node, index) => (
      <Accordion.Item
        key={`${node?._id}_${index}`}
        eventKey={node?._id?.toString()}
      >
        <Accordion.Header className={`accordion-header level-${level}`}>
          <div
            className="maininnerbtn"
            style={{ paddingLeft: `${level * 20}px` }}
          >
            <label className="cyberpunk-checkbox-label">
              <input
                type="checkbox"
                className="cyberpunk-checkbox"
                checked={areAllChildrenSelected(node)}
                onChange={() => handleParentCheckboxChange(node)}
              />
            </label>
            <div className="projectmain">
              <p className="projectpara">{node?.name}</p>
            </div>
          </div>
        </Accordion.Header>
        <Accordion.Body>
          {Object.keys(node).map((key) => {
            if (Array.isArray(node[key]) && node[key].length > 0) {
              return (
                <Accordion key={key} defaultActiveKey="0">
                  {renderHierarchy(node[key], level + 1)}
                </Accordion>
              );
            }
            return null;
          })}
        </Accordion.Body>
      </Accordion.Item>
    ));
  };

  const allEventKeys = getAllEventKeys(leaderNames);

  function convertToTitleCase(input) {
    // // console.log("cccc");
    if (input) {
      let words = input
        .split("_")
        .map(
          (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        );

      if (words[0] === "mini" || words[0] === "Mini") {
        return "Ambassador";
      }
      if (
        words[words.length - 1].toLowerCase() === "agent" &&
        (words[0] != "mini" || words[0] != "Mini")
      ) {
        words[words.length - 1] = "Leader";
      }
      if (words[0] === "super" || words[0] === "Super") {
        return "Super";
      } else if (words[0] !== "agent") {
        return words.join(" ");
      } else {
        return "Leader";
      }
    } else {
      return "";
    }
  }
  return (
    <>
      <section className="alltransaction">
        <div className="custom-container">
          {/* <button
            class="btn-back guvxgyvxvtxx"
            onClick={() => functiontogetback()}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
            >
              <path
                d="M8.37376 16.4675C8.20751 16.4675 8.04126 16.4062 7.91001 16.275L2.59876 10.9637C2.34501 10.71 2.34501 10.29 2.59876 10.0362L7.91001 4.72498C8.16376 4.47123 8.58376 4.47123 8.83751 4.72498C9.09126 4.97873 9.09126 5.39873 8.83751 5.65248L3.99001 10.5L8.83751 15.3475C9.09126 15.6012 9.09126 16.0212 8.83751 16.275C8.71501 16.4062 8.54001 16.4675 8.37376 16.4675Z"
                fill="black"
              ></path>
              <path
                d="M17.9375 11.1562H3.21124C2.85249 11.1562 2.55499 10.8587 2.55499 10.5C2.55499 10.1413 2.85249 9.84375 3.21124 9.84375H17.9375C18.2962 9.84375 18.5937 10.1413 18.5937 10.5C18.5937 10.8587 18.2962 11.1562 17.9375 11.1562Z"
                fill="black"
              ></path>
            </svg>{" "}
            Back
          </button>
          <div className="main-heading">
            <h6>All Transactions</h6>
            {user?.role == "god_agent" && user?.specialAccess?.length > 0 ? (
              <div className="set-twice-text">
                <div className="parent-toggle-switch-custom">
                  <div class="custom-toggle">
                    <input
                      type="checkbox"
                      class="checkbox"
                      id="checkbox"
                      checked={myTree}
                      onChange={(e) => {
                        setMyTree(e.target.checked);
                      }}
                    />
                    <label class="switch" for="checkbox">
                      <span class="slider"></span>
                    </label>
                  </div>
                </div>
                <h6>Show data from my tree only</h6>
              </div>
            ) : null}
          </div>
          {user?.role == "admin" ? (
            <div className="bottom-cards">
              <div className="single-card">
                <img
                  src="\assets\dashboard\noofpurchases.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>Number of Purchases</p>
                <h6>{adminobj?.TotalPurchases}</h6>
              </div>
              <div className="single-card">
                <img
                  src="/assets/incentive-purchased.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>INCENTIV Purchased</p>
                {adminobj?.totalDopPurchased ? (
                  <h6>
                    {parseInt(
                      (
                        tokenNftStats.stats[0]?.totalDopPurchased +
                        tokenNftStats.nftStats[0]?.totalDopPurchased
                      )?.toFixed(2)
                    ).toLocaleString("en-US")}{" "}
                    &nbsp;INC
                  </h6>
                ) : (
                  <h6>0.00 INC</h6>
                )}
                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseFloat(
                          tokenNftStats?.stats[0]?.totalDopPurchased?.toFixed(4)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    Token
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {tokenNftStats
                      ? parseInt(
                          tokenNftStats?.nftStats[0]?.totalDopPurchased?.toFixed(
                            2
                          )
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    NFT
                  </p>
                </div>
              </div>
              <div className="single-card">
                <img
                  src="\assets\dashboard\purchasedamount.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>Purchased Amount</p>
                {usdPrice && adminobj ? (
                  <h6 className="datahead">
                    ~$
                    {parseInt(
                      (
                        usdPrice * adminobj?.totalPurchaseEth +
                        adminobj?.totalPurchaseUsdt +
                        dopPrice * adminobj?.totalPurchaseDopToken +
                        btcPrice * adminobj?.totalPurchaseWbtc +
                        adminobj?.totalPurchaseUsdc +
                        pepePrice * adminobj?.totalPurchasePepe +
                        linkPrice * adminobj?.totalPurchaseLink +
                        uniPrice * adminobj?.totalPurchaseUni
                      )?.toFixed(2)
                    ).toLocaleString("en-US")}{" "}
                  </h6>
                ) : (
                  <h6 className="datahead">~$0.00 USD</h6>
                )}
                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {adminobj ? adminobj?.totalPurchaseEth?.toFixed(4) : 0} ETH
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseUsdt?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDT
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseDopToken?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    DOP
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseWbtc?.toFixed(5)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    WBTC
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseUsdc?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    USDC
                  </p>
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchasePepe?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    PEPE
                  </p>{" "}
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseLink?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    LINK
                  </p>{" "}
                  <p className="uni-text">
                    <span></span>
                    {adminobj
                      ? parseFloat(
                          adminobj?.totalPurchaseUni?.toFixed(2)
                        )?.toLocaleString("en-US")
                      : 0}{" "}
                    UNI
                  </p>
                </div>
              </div>
            </div>
          ) : (
            <div className="bottom-cards">
              <div className="single-card">
                <img
                  src="\assets\dashboard\noofpurchases.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>Number of Purchases</p>
                {pdp?.length > 0 ? (
                  <h6>
                    {pdp[0]?.TotalPurchases > 0 ? pdp[0]?.TotalPurchases : 0}{" "}
                    <span className={pc > 0 ? "green-text" : "red-text"}>
                      {pc ? pc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                ) : (
                  <h6>0</h6>
                )}
              </div>
              <div className="single-card">
                <img
                  src="/assets/incentive-purchased.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>INCENTIV Purchased</p>
                {usdPrice && pdp ? (
                  <h6>
                    {pdp[0]?.totalDopPurchased > 0
                      ? parseFloat(pdp[0]?.totalDopPurchased)
                          .toFixed(2)
                          ?.toLocaleString("en-US")
                      : 0}
                    &nbsp;INC{" "}
                    <span className={dpc > 0 ? "green-text" : "red-text"}>
                      {dpc ? dpc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                ) : (
                  <h6>0.00 INC</h6>
                )}
                <div className="bottom-text">
                  <p className="uni-text">
                    <span></span>
                    {dt[0]?.totalDirectDop
                      ? dt[0]?.totalDirectDop?.toFixed(4)
                      : 0}
                  </p>
                  <p className="uni-text">
                    <span></span>~
                    {ind[0]?.totalInDirectDop
                      ? ind[0]?.totalInDirectDop?.toFixed(4)
                      : 0}
                  </p>
                </div>
              </div>
              <div className="single-card">
                <img
                  src="\assets\dashboard\purchasedamount.svg"
                  alt="img"
                  className="img-fluid"
                />
                <p>Purchased Amount</p>
                {(usdPrice && pee) || peu || (tomiPrice && pet) ? (
                  <h6 className="datahead">
                    {pee?.length > 0
                      ? "~$" +
                        parseFloat(
                          (
                            usdPrice *
                              (pee[0]?.totalPurchaseEth
                                ? pee[0]?.totalPurchaseEth
                                : 0) +
                            (peu[0]?.totalPurchaseUsdt
                              ? peu[0]?.totalPurchaseUsdt
                              : 0) +
                            tomiPrice *
                              (pet[0]?.totalPurchaseTomi
                                ? pet[0]?.totalPurchaseTomi
                                : 0) +
                            btcPrice *
                              (peBtc[0]?.totalPurchaseWbtc
                                ? peBtc[0]?.totalPurchaseWbtc
                                : 0) +
                            pepePrice *
                              (pePepe[0]?.totalPurchasePepe
                                ? pePepe[0]?.totalPurchasePepe
                                : 0) +
                            linkPrice *
                              (peLink[0]?.totalPurchaseLink
                                ? peLink[0]?.totalPurchaseLink
                                : 0) +
                            uniPrice *
                              (peUni[0]?.totalPurchaseUni
                                ? peUni[0]?.totalPurchaseUni
                                : 0) +
                            dopPrice *
                              (peUni[0]?.totalPurchaseDopToken
                                ? peUni[0]?.totalPurchaseDopToken
                                : 0)
                          )?.toFixed(4)
                        ).toLocaleString("en-US")
                      : 0}{" "}
                    <span className={pmc > 0 ? "green-text" : "red-text"}>
                      {pmc ? pmc.toFixed(1) + "% " : ""}
                    </span>
                  </h6>
                ) : (
                  <h6 className="datahead">~$0.00 USD</h6>
                )}
                {pee?.length > 0 ? (
                  <div className="bottom-text">
                    <p className="uni-text">
                      <span></span>
                      {pee[0]?.totalPurchaseEth
                        ? pee[0]?.totalPurchaseEth?.toFixed(4)
                        : 0}{" "}
                      ETH
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {peu[0]?.totalPurchaseUsdt
                        ? parseFloat(
                            peu[0]?.totalPurchaseUsdt?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      USDT
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {pet[0]?.totalPurchaseDopToken
                        ? parseFloat(
                            pet[0]?.totalPurchaseDopToken?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      DOP
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {peBtc[0]?.totalPurchaseWbtc
                        ? parseFloat(
                            peBtc[0]?.totalPurchaseWbtc?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      WBTC
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {peUsdc[0]?.totalPurchaseUsdc
                        ? parseFloat(
                            peUsdc[0]?.totalPurchaseUsdc?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      USDC
                    </p>
                    <p className="uni-text">
                      <span></span>
                      {pePepe[0]?.totalPurchasePepe
                        ? parseFloat(
                            pePepe[0]?.totalPurchasePepe?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      PEPE
                    </p>{" "}
                    <p className="uni-text">
                      <span></span>
                      {peLink[0]?.totalPurchaseLink
                        ? parseFloat(
                            peLink[0]?.totalPurchaseLink?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      LINK
                    </p>{" "}
                    <p className="uni-text">
                      <span></span>
                      {peUni[0]?.totalPurchaseUni
                        ? parseFloat(
                            pet[0]?.totalPurchaseUni?.toFixed(2)
                          )?.toLocaleString("en-US")
                        : 0}{" "}
                      UNI
                    </p>
                  </div>
                ) : (
                  <div className="bottom-text">
                    <p className="uni-text">
                      <span></span>0 ETH
                    </p>
                    <p className="uni-text">
                      <span></span>0 USDT
                    </p>
                    <p className="uni-text">
                      <span></span>0 DOP
                    </p>
                    <p className="uni-text">
                      <span></span>0 WBTC
                    </p>
                    <p className="uni-text">
                      <span></span>0 USDC
                    </p>
                    <p className="uni-text">
                      <span></span>0 PEPE
                    </p>{" "}
                    <p className="uni-text">
                      <span></span>0 LINK
                    </p>{" "}
                    <p className="uni-text">
                      <span></span>0 UNI
                    </p>
                  </div>
                )}
              </div>
            </div>
          )} */}
          <div className="main-heading">
            <div>
              <p className="selfhead">Premium Projects</p>
              {/* <p className="selfhead">self serve Projects</p> */}
              {user?.accessCode ? (
                <h6>All Transactions</h6>
              ) : (
                <h6>All Transactions</h6>
              )}
            </div>

            <div className="multi-items">
              {user?.role == "god_agent" && user?.specialAccess?.length > 0 ? (
                <div className="set-twice-text">
                  <div className="parent-toggle-switch-custom">
                    <div class="custom-toggle">
                      <input
                        type="checkbox"
                        class="checkbox"
                        id="checkbox"
                        checked={myTree}
                        onChange={(e) => {
                          setMyTree(e.target.checked);
                        }}
                      />
                      <label class="switch" for="checkbox">
                        <span class="slider"></span>
                      </label>
                    </div>
                  </div>
                  <h6>Show data from my tree only</h6>
                </div>
              ) : null}

              <div className="rightside-content">
                <div className="custom-option-field" style={{ width: "575px" }}>
                  {/* <Dropdown
                    className="positionset"
                    style={{ maxWidth: "75px" }}
                  >
                    <Dropdown.Toggle id="dropdown-basic">
                      By Hash
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="7"
                        viewBox="0 0 13 7"
                        fill="none"
                      >
                        <path
                          d="M0 0.5L2.22397e-07 3.0462L6.2 6.5L6.2 3.9538L0 0.5Z"
                          fill="#02171D"
                        />
                        <path
                          d="M12.3984 0.5L12.3984 3.0462L6.19844 6.5L6.19844 3.9538L12.3984 0.5Z"
                          fill="#02171D"
                        />
                      </svg>
                    </Dropdown.Toggle>
                  </Dropdown> */}
                  <input
                    // style={{ paddingLeft: "90px" }}
                    type="search"
                    placeholder="Search by Access Code, Wallet, Trx Hash..."
                    onChange={(e) => {
                      if (page != 0) {
                        setPage(0);
                      }
                      setSearch(e.target.value);
                    }}
                  />
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="img-fluid search-icon"
                  >
                    <path
                      d="M7.66671 14.5C3.90004 14.5 0.833374 11.4334 0.833374 7.66671C0.833374 3.90004 3.90004 0.833374 7.66671 0.833374C11.4334 0.833374 14.5 3.90004 14.5 7.66671C14.5 11.4334 11.4334 14.5 7.66671 14.5ZM7.66671 1.83337C4.44671 1.83337 1.83337 4.45337 1.83337 7.66671C1.83337 10.88 4.44671 13.5 7.66671 13.5C10.8867 13.5 13.5 10.88 13.5 7.66671C13.5 4.45337 10.8867 1.83337 7.66671 1.83337Z"
                      fill="#05BADA"
                    />
                    <path
                      d="M14.6666 15.1666C14.54 15.1666 14.4133 15.12 14.3133 15.02L12.98 13.6866C12.7866 13.4933 12.7866 13.1733 12.98 12.98C13.1733 12.7866 13.4933 12.7866 13.6866 12.98L15.02 14.3133C15.2133 14.5066 15.2133 14.8266 15.02 15.02C14.92 15.12 14.7933 15.1666 14.6666 15.1666Z"
                      fill="#05BADA"
                    />
                  </svg>
                </div>

                <button className="whitnewbtn" onClick={handleShow3}>
                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6 7.33334V11.3333L7.33333 10" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.99984 11.3333L4.6665 10" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6668 6.66668V10C14.6668 13.3333 13.3335 14.6667 10.0002 14.6667H6.00016C2.66683 14.6667 1.3335 13.3333 1.3335 10V6.00001C1.3335 2.66668 2.66683 1.33334 6.00016 1.33334H9.3335" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6668 6.66668H12.0002C10.0002 6.66668 9.3335 6.00001 9.3335 4.00001V1.33334L14.6668 6.66668Z" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                  Filter
                </button>
                {transactions?.length == 0 && (
                  <div className="upperbtn">
                    <button
                      onClick={toastErrorFunc}
                      className="downloadcsvcustombutton"
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6 7.33334V11.3333L7.33333 10" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.99984 11.3333L4.6665 10" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6668 6.66668V10C14.6668 13.3333 13.3335 14.6667 10.0002 14.6667H6.00016C2.66683 14.6667 1.3335 13.3333 1.3335 10V6.00001C1.3335 2.66668 2.66683 1.33334 6.00016 1.33334H9.3335" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6668 6.66668H12.0002C10.0002 6.66668 9.3335 6.00001 9.3335 4.00001V1.33334L14.6668 6.66668Z" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                      Click To Export
                    </button>
                  </div>
                )}
                {transactions?.length != 0 && (
                  <div className="">
                    <div className="upperbtn">
                      {showbtn && (
                        <button
                          className="downloadcsvcustombutton"
                          onClick={getAllClaimsData}
                        >
                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M6 7.33334V11.3333L7.33333 10" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5.99984 11.3333L4.6665 10" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6668 6.66668V10C14.6668 13.3333 13.3335 14.6667 10.0002 14.6667H6.00016C2.66683 14.6667 1.3335 13.3333 1.3335 10V6.00001C1.3335 2.66668 2.66683 1.33334 6.00016 1.33334H9.3335" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M14.6668 6.66668H12.0002C10.0002 6.66668 9.3335 6.00001 9.3335 4.00001V1.33334L14.6668 6.66668Z" stroke="#05BADA" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                          Click To Export
                        </button>
                      )}
                      {loading ? (
                        <button className="mygreybtn">
                          <div className="text-center">
                            <div class="d-flex align-items-center justify-content-center">
                              <div
                                class="spinner-border text-info"
                                role="status"
                              >
                                <span class="sr-only"></span>
                              </div>
                            </div>
                          </div>
                        </button>
                      ) : (
                        <>
                          {claimsCSVData && claimsCSVData.length > 0 && (
                            <CSVLink
                              className="downloadcsvcustombutton"
                              data={claimsCSVData}
                              headers={claimsCSVDataHeaders}
                              filename={"Transactions_data.csv"}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="17"
                                viewBox="0 0 16 17"
                                fill="none"
                              >
                                <path
                                  d="M6 7.83334V11.8333L7.33333 10.5"
                                  stroke="black"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M5.99984 11.8333L4.6665 10.5"
                                  stroke="black"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M14.6668 7.16668V10.5C14.6668 13.8333 13.3335 15.1667 10.0002 15.1667H6.00016C2.66683 15.1667 1.3335 13.8333 1.3335 10.5V6.50001C1.3335 3.16668 2.66683 1.83334 6.00016 1.83334H9.3335"
                                  stroke="black"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M14.6668 7.16668H12.0002C10.0002 7.16668 9.3335 6.50001 9.3335 4.50001V1.83334L14.6668 7.16668Z"
                                  stroke="black"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                              Download CSV
                            </CSVLink>
                            // <CSVLink
                            //   data={claimsCSVData}
                            //   headers={claimsCSVDataHeaders}
                            //   filename={"Transactions_data.csv"}
                            //   className="mygreybtn"
                            // >
                            //   Download CSV
                            // </CSVLink>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <DataTable
            page={page}
            handlePageClick={handlePageChange}
            setSearch={setSearch}
            search={search}
            usdPrice={usdPrice}
            transactions={transactions}
            transactionApiCalled={transactionApiCalled}
            // setTransactions={setTransactions}
            pageCount={pageCount}
            user={user}
            setOrderDirection={setOrderDirection}
            setOrderField={setOrderField}
            tok={tok}
            selectedLeaders={selectedLeaders}
            selectedRoles={selectedRoles}
            searchBy={searchBy}
            selectedAccessCodes={selectedAccessCodes}
            selectedWallets={selectedWallets}
            privateSaleFilter={privateSaleFilter}
            orderDirection={orderDirection}
            orderField={orderField}
          />

          <div className="footer-content mt-2">
            <div className="left-f">
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
              {/* <h6>SHOWING 1-10 OF 145</h6> */}
            </div>
            <div className="right-f">
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <nav aria-label="Page navigation example">
                    <ul class="text-center">
                      <ReactPaginate
                        previousLabel={
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M12.6665 8L3.33317 8" stroke="#042B33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 3.33329L3.33333 7.99996L8 12.6666" stroke="#042B33" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                        }
                        nextLabel={
                         <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M3.3335 8L12.6668 8" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 3.33329L12.6667 7.99996L8 12.6666" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
                        }
                        pageClassName="page-item"
                        pageLinkClassName="page-link"
                        previousClassName="page-item"
                        previousLinkClassName="page-link"
                        nextClassName="page-item"
                        nextLinkClassName="page-link"
                        breakLabel="..."
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        containerClassName="pagination"
                        activeClassName="active"
                        forcePage={page}
                      ></ReactPaginate>
                    </ul>
                  </nav>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <Offcanvas
        show={show3}
        onHide={handleClose3}
        placement="end"
        className="leadersfilter"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              Projects & Rounds
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="8"
                viewBox="0 0 14 8"
                fill="none"
              >
                <path
                  d="M12.9182 0.178772H6.68816H1.07816C0.118161 0.178772 -0.361838 1.33877 0.318162 2.01877L5.49816 7.19877C6.32816 8.02877 7.67816 8.02877 8.50816 7.19877L10.4782 5.22877L13.6882 2.01877C14.3582 1.33877 13.8782 0.178772 12.9182 0.178772Z"
                  fill="#fff"
                />
              </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Accordion defaultActiveKey={null}>
                {roundsData.map((project, projectIndex) => (
                  <Accordion.Item
                    key={projectIndex}
                    eventKey={projectIndex.toString()}
                  >
                    <Accordion.Header>
                      <div className="maininnerbtn">
                        <label className="cyberpunk-checkbox-label">
                          <input
                            type="checkbox"
                            className="cyberpunk-checkbox"
                            checked={privateSaleFilter.some(
                              (item) =>
                                item.privateSale === project.privateSale &&
                                item.round.length === project.totalRounds
                            )}
                            onChange={() => {
                              // Check/uncheck all rounds
                              const allRoundsSelected = privateSaleFilter.some(
                                (item) =>
                                  item.privateSale === project.privateSale &&
                                  item.round.length === project.totalRounds
                              );
                              if (allRoundsSelected) {
                                project.rounds.forEach((round) => {
                                  handleCheckboxChangeRounds(
                                    project.privateSale,
                                    round
                                  );
                                });
                              } else {
                                for (let i = 1; i <= project.totalRounds; i++) {
                                  handleCheckboxChangeRounds(
                                    project.privateSale,
                                    i
                                  );
                                }
                              }
                            }}
                          />
                        </label>
                        <div className="projectmain">
                          <div className="projectmainimg">
                            {/* {console.log(Environment?.PROJECTS,Environment?.PROJECTS[project?.privateSale], 'legacyExports')} */}
                            <img
                              src={Environment?.PROJECTS[project?.privateSale]?.imageSrc ?? `/assets/${project.privateSale.toLowerCase()}.svg`}
                              alt="projectinnerimg"
                              className="projectinnerimg"
                            />
                          </div>
                          <p className="projectpara">{project.privateSale}</p>
                        </div>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      {Array.from(
                        { length: project.totalRounds },
                        (_, roundIndex) => (
                          <div key={roundIndex} className="inneracc">
                            <label className="cyberpunk-checkbox-label">
                              <input
                                type="checkbox"
                                className="cyberpunk-checkbox"
                                checked={privateSaleFilter.some(
                                  (item) =>
                                    item.privateSale === project.privateSale &&
                                    item.round.includes(roundIndex + 1)
                                )}
                                onChange={() =>
                                  handleCheckboxChangeRounds(
                                    project.privateSale,
                                    roundIndex + 1
                                  )
                                }
                              />
                            </label>
                            <p className="inneracccpara">
                              Round {roundIndex + 1}
                            </p>
                          </div>
                        )
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </Dropdown.Menu>
          </Dropdown>
          <div className="spanmain">
            {privateSaleFilter.map((project) =>
              project.round.map((round, index) => {
                return (
                  <div
                    className="innerspan"
                    key={index}
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      handleCheckboxChangeRounds(project.privateSale, round);
                    }}
                  >
                    {project.privateSale} Round {round}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="18"
                      viewBox="0 0 18 18"
                      fill="none"
                    >
                      <path
                        d="M5.14282 12.8571L12.8571 5.14282"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M12.8571 12.8571L5.14282 5.14282"
                        stroke="white"
                        stroke-width="1.2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                );
              })
            )}
          </div>
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              By Leader Name
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="8"
                viewBox="0 0 14 8"
                fill="none"
              >
                <path
                  d="M12.9182 0.178772H6.68816H1.07816C0.118161 0.178772 -0.361838 1.33877 0.318162 2.01877L5.49816 7.19877C6.32816 8.02877 7.67816 8.02877 8.50816 7.19877L10.4782 5.22877L13.6882 2.01877C14.3582 1.33877 13.8782 0.178772 12.9182 0.178772Z"
                  fill="#fff"
                />
              </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <div className="searchinput">
                <input
                  type="text"
                  placeholder="Search"
                  className="innerinput"
                  value={searchInputLeaders}
                  onChange={handleSearchChangeLeaders}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  className="searchimg"
                >
                  <path
                    d="M7.66671 14.5002C3.90004 14.5002 0.833374 11.4335 0.833374 7.66683C0.833374 3.90016 3.90004 0.833496 7.66671 0.833496C11.4334 0.833496 14.5 3.90016 14.5 7.66683C14.5 11.4335 11.4334 14.5002 7.66671 14.5002ZM7.66671 1.8335C4.44671 1.8335 1.83337 4.4535 1.83337 7.66683C1.83337 10.8802 4.44671 13.5002 7.66671 13.5002C10.8867 13.5002 13.5 10.8802 13.5 7.66683C13.5 4.4535 10.8867 1.8335 7.66671 1.8335Z"
                    fill="#929292"
                  />
                  <path
                    d="M14.6666 15.1666C14.54 15.1666 14.4133 15.12 14.3133 15.02L12.98 13.6866C12.7866 13.4933 12.7866 13.1733 12.98 12.98C13.1733 12.7866 13.4933 12.7866 13.6866 12.98L15.02 14.3133C15.2133 14.5066 15.2133 14.8266 15.02 15.02C14.92 15.12 14.7933 15.1666 14.6666 15.1666Z"
                    fill="#929292"
                  />
                </svg>
              </div>
              <Accordion defaultActiveKey={allEventKeys}>
                {renderHierarchy(leaderNames2)}
              </Accordion>
            </Dropdown.Menu>
          </Dropdown>
          <div className="spanmain">
            {selectedLeaders?.length > 0
              ? selectedLeaders?.map((item) => {
                  return (
                    <div
                      className="innerspan"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleCheckboxChangeLeaders(item);
                      }}
                    >
                      {item?.name}

                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M5.14282 12.8571L12.8571 5.14282"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.8571 12.8571L5.14282 5.14282"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  );
                })
              : null}
          </div>
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              Purchaser’s Wallet Address
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="8"
                viewBox="0 0 14 8"
                fill="none"
              >
                <path
                  d="M12.9182 0.178772H6.68816H1.07816C0.118161 0.178772 -0.361838 1.33877 0.318162 2.01877L5.49816 7.19877C6.32816 8.02877 7.67816 8.02877 8.50816 7.19877L10.4782 5.22877L13.6882 2.01877C14.3582 1.33877 13.8782 0.178772 12.9182 0.178772Z"
                  fill="#fff"
                />
              </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <div className="searchinput">
                <input
                  type="text"
                  placeholder="Search"
                  className="innerinput"
                  value={searchInput}
                  onChange={handleSearchChangeWallet}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  className="searchimg"
                >
                  <path
                    d="M7.66671 14.5002C3.90004 14.5002 0.833374 11.4335 0.833374 7.66683C0.833374 3.90016 3.90004 0.833496 7.66671 0.833496C11.4334 0.833496 14.5 3.90016 14.5 7.66683C14.5 11.4335 11.4334 14.5002 7.66671 14.5002ZM7.66671 1.8335C4.44671 1.8335 1.83337 4.4535 1.83337 7.66683C1.83337 10.8802 4.44671 13.5002 7.66671 13.5002C10.8867 13.5002 13.5 10.8802 13.5 7.66683C13.5 4.4535 10.8867 1.8335 7.66671 1.8335Z"
                    fill="#929292"
                  />
                  <path
                    d="M14.6666 15.1666C14.54 15.1666 14.4133 15.12 14.3133 15.02L12.98 13.6866C12.7866 13.4933 12.7866 13.1733 12.98 12.98C13.1733 12.7866 13.4933 12.7866 13.6866 12.98L15.02 14.3133C15.2133 14.5066 15.2133 14.8266 15.02 15.02C14.92 15.12 14.7933 15.1666 14.6666 15.1666Z"
                    fill="#929292"
                  />
                </svg>
              </div>
              {filteredWallets?.length > 0
                ? filteredWallets?.map((item) => (
                    <div className="inneritem" key={item?.buyersWallet}>
                      <label className="cyberpunk-checkbox-label">
                        <input
                          type="checkbox"
                          className="cyberpunk-checkbox"
                          checked={selectedWallets.includes(item?.buyersWallet)}
                          onChange={() =>
                            handleCheckboxChangeWallet(item?.buyersWallet)
                          }
                        />
                      </label>
                      <p className="inneracccpara">{item?.buyersWallet}</p>
                    </div>
                  ))
                : null}
            </Dropdown.Menu>
          </Dropdown>
          <div className="spanmain">
            {selectedWallets?.length > 0
              ? selectedWallets?.map((item) => {
                  return (
                    <div
                      className="innerspan"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleCheckboxChangeWallet(item);
                      }}
                    >
                      {item}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M5.14282 12.8571L12.8571 5.14282"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.8571 12.8571L5.14282 5.14282"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  );
                })
              : null}
          </div>
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              Leader Code
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="8"
                viewBox="0 0 14 8"
                fill="none"
              >
                <path
                  d="M12.9182 0.178772H6.68816H1.07816C0.118161 0.178772 -0.361838 1.33877 0.318162 2.01877L5.49816 7.19877C6.32816 8.02877 7.67816 8.02877 8.50816 7.19877L10.4782 5.22877L13.6882 2.01877C14.3582 1.33877 13.8782 0.178772 12.9182 0.178772Z"
                  fill="#fff"
                />
              </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <div className="searchinput">
                <input
                  type="text"
                  placeholder="Search"
                  className="innerinput"
                  value={searchInputAccessCodes}
                  onChange={handleSearchChangeAccessCodes}
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  className="searchimg"
                >
                  <path
                    d="M7.66671 14.5002C3.90004 14.5002 0.833374 11.4335 0.833374 7.66683C0.833374 3.90016 3.90004 0.833496 7.66671 0.833496C11.4334 0.833496 14.5 3.90016 14.5 7.66683C14.5 11.4335 11.4334 14.5002 7.66671 14.5002ZM7.66671 1.8335C4.44671 1.8335 1.83337 4.4535 1.83337 7.66683C1.83337 10.8802 4.44671 13.5002 7.66671 13.5002C10.8867 13.5002 13.5 10.8802 13.5 7.66683C13.5 4.4535 10.8867 1.8335 7.66671 1.8335Z"
                    fill="#929292"
                  />
                  <path
                    d="M14.6666 15.1666C14.54 15.1666 14.4133 15.12 14.3133 15.02L12.98 13.6866C12.7866 13.4933 12.7866 13.1733 12.98 12.98C13.1733 12.7866 13.4933 12.7866 13.6866 12.98L15.02 14.3133C15.2133 14.5066 15.2133 14.8266 15.02 15.02C14.92 15.12 14.7933 15.1666 14.6666 15.1666Z"
                    fill="#929292"
                  />
                </svg>
              </div>
              {filteredAccessCodes?.length > 0
                ? filteredAccessCodes?.map((item) => (
                    <div className="inneritem" key={item?.accessCode}>
                      <label className="cyberpunk-checkbox-label">
                        <input
                          type="checkbox"
                          className="cyberpunk-checkbox"
                          checked={selectedAccessCodes.includes(
                            item?.accessCode
                          )}
                          onChange={() =>
                            handleCheckboxChangeAccessCodes(item?.accessCode)
                          }
                        />
                      </label>
                      <p className="inneracccpara">{item?.accessCode}</p>
                    </div>
                  ))
                : null}
            </Dropdown.Menu>
          </Dropdown>
          <div className="spanmain">
            <div className="inneritem">
              {selectedAccessCodes?.length > 0
                ? selectedAccessCodes?.map((item) => {
                    return (
                      <div
                        className="innerspan"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          handleCheckboxChangeAccessCodes(item);
                        }}
                      >
                        {item}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                        >
                          <path
                            d="M5.14282 12.8571L12.8571 5.14282"
                            stroke="white"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.8571 12.8571L5.14282 5.14282"
                            stroke="white"
                            stroke-width="1.2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    );
                  })
                : null}
            </div>
          </div>
          <Dropdown>
            <Dropdown.Toggle id="dropdown-basic">
              Role
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="8"
                viewBox="0 0 14 8"
                fill="none"
              >
                <path
                  d="M12.9182 0.178772H6.68816H1.07816C0.118161 0.178772 -0.361838 1.33877 0.318162 2.01877L5.49816 7.19877C6.32816 8.02877 7.67816 8.02877 8.50816 7.19877L10.4782 5.22877L13.6882 2.01877C14.3582 1.33877 13.8782 0.178772 12.9182 0.178772Z"
                  fill="#fff"
                />
              </svg>
            </Dropdown.Toggle>

            <Dropdown.Menu>
              {/* <div className="searchinput">
                <input
                  type="text"
                  placeholder="Search"
                  className="innerinput"
                />
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  className="searchimg"
                >
                  <path
                    d="M7.66671 14.5002C3.90004 14.5002 0.833374 11.4335 0.833374 7.66683C0.833374 3.90016 3.90004 0.833496 7.66671 0.833496C11.4334 0.833496 14.5 3.90016 14.5 7.66683C14.5 11.4335 11.4334 14.5002 7.66671 14.5002ZM7.66671 1.8335C4.44671 1.8335 1.83337 4.4535 1.83337 7.66683C1.83337 10.8802 4.44671 13.5002 7.66671 13.5002C10.8867 13.5002 13.5 10.8802 13.5 7.66683C13.5 4.4535 10.8867 1.8335 7.66671 1.8335Z"
                    fill="#929292"
                  />
                  <path
                    d="M14.6666 15.1666C14.54 15.1666 14.4133 15.12 14.3133 15.02L12.98 13.6866C12.7866 13.4933 12.7866 13.1733 12.98 12.98C13.1733 12.7866 13.4933 12.7866 13.6866 12.98L15.02 14.3133C15.2133 14.5066 15.2133 14.8266 15.02 15.02C14.92 15.12 14.7933 15.1666 14.6666 15.1666Z"
                    fill="#929292"
                  />
                </svg>
              </div> */}
              <div className="inneritem">
                <label className="cyberpunk-checkbox-label">
                  <input
                    type="checkbox"
                    className="cyberpunk-checkbox"
                    checked={isAllRolesSelected}
                    onChange={() => handleCheckboxChange("all")}
                  />
                </label>
                <p className="inneracccpara">All Roles</p>
              </div>

              {roles.map((role) => (
                <div className="inneritem" key={role}>
                  <label className="cyberpunk-checkbox-label">
                    <input
                      type="checkbox"
                      className="cyberpunk-checkbox"
                      checked={selectedRoles.includes(role)}
                      onChange={() => handleCheckboxChange(role)}
                    />
                  </label>
                  <p className="inneracccpara"> {convertToTitleCase(role)}</p>
                </div>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          <div className="spanmain">
            {selectedRoles?.length > 0
              ? selectedRoles?.map((item) => {
                  return (
                    <div
                      className="innerspan"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        handleCheckboxChange(item);
                      }}
                    >
                      {convertToTitleCase(item)}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 18 18"
                        fill="none"
                      >
                        <path
                          d="M5.14282 12.8571L12.8571 5.14282"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.8571 12.8571L5.14282 5.14282"
                          stroke="white"
                          stroke-width="1.2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </div>
                  );
                })
              : null}
          </div>

          <div className="bottombtns">
            <button
              className="whitebtn"
              onClick={() => {
                // setSearch("");
                // setRoundFilter([]);
                // setLeaderNameFilter("");
                // setSaleTypeFilter("");
                setPrivateSaleFilter([]);
                setSelectedLeaders([]);
                setSelectedRoles([]);
                setSelectedAccessCodes([]);
                setSelectedWallets([]);
              }}
            >
              Clear all
            </button>
            <button
              className="greybtn"
              onClick={() => {
                getTransactionsData();
                handleClose3();
              }}
            >
              Apply
            </button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default AllTransaction;
